import { render } from "./ClientDocuments.vue?vue&type=template&id=20bf1856"
import script from "./ClientDocuments.vue?vue&type=script&lang=js"
export * from "./ClientDocuments.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__